import React from "react";
import { Provider } from "components/citizen-otp/CitizenOTPContext";
import ThongKeSoLieu from "components/thong-ke-so-lieu";

export const ThongKe = () => {
    return (
        <Provider>
            <ThongKeSoLieu />
        </Provider>
    );
};
